import { render, staticRenderFns } from "./itemSelect.vue?vue&type=template&id=36fbb4b7&"
import script from "./itemSelect.vue?vue&type=script&lang=ts&"
export * from "./itemSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports